import { request, errHandler } from "./heimdall";
import store from "../store";

/* Mantis API requests */
/* Get all users id & name */
export function getEmployees() {
  return request
    .get(`/employees/list`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get all info for an employee */
export function getEmployeeInfo(data) {
  return request
    .get(`/employees/${data.id}`, {
      params: {
        password: data.password
      },
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get last financial data of an employee in db */
export function getLastUserPrice(data) {
  return request
    .get(`/employees/lastprice/${data.id}`, {
      params: {
        date: data.date,
        password: data.password
      },
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get all info for an employee at a given date */
export function getPriceInfo(data) {
  return request
    .get(`/employees/price/${data.id}`, {
      params: {
        password: data.password
      },
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get past info for an employee */
export function getEmployeePastInfo({ id = [''], password = '' }) {
  return request
    .get(`/employees/past`, {
      params: {
        usersId: id,
        password: password
      },
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get future info for an employee */
export function getEmployeeFutureInfo({ id = [''], password = '' }) {
  return request
    .get(`/employees/future`, {
      params: {
        ids: id,
        password: password
      },
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get all employees info for current month */
export function getAllEmployeesInfo(data) {
  return request
    .get(`/employees`, {
      params: {
        password: data.password
      },
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Create project into project_info db */
export function createEmployee(params) {
  return request
    .post(`/employees`, params, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Update project into project_info db */
export function updateEmployee(params) {
  return request
    .put(`/employees`, params, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}